import Languages, { Language } from "src/constants/Languages";
import Config from "src/constants/Config";
import DebugUtil from "src/utils/DebugUtil";

export interface AudioTranslation {
    /** The translation key in expanded form
     *
     *      "Landscaping.Intro.first"
     */
    key: string;
    url?: string;
    language?: Language;
}

export default class AudioTranslations {

    public static FindByKeyAndLanguage(key: string, languageCode: string): AudioTranslation {
        if (DebugUtil.isDebugEnabled()) {
            console.warn("Language Key", key); // JB - Remove this console.warn
        }
        let languageCodeEnhanced = languageCode.toLowerCase();
        let url = Config.GetAzureUrl(key, "audio", languageCodeEnhanced);

        return {
            key: key,
            language: Languages.FindByCode(languageCodeEnhanced),
            url: url,
        } as AudioTranslation;
    }

    public static FindByKey(key: string): AudioTranslation {
        // Assume we want the current language
        let language = Languages.GetActiveLanguage();
        return this.FindByKeyAndLanguage(key, language.code);
    }
}



// WEBPACK FOOTER //
// ./src/constants/AudioTranslations.ts